/* eslint-disable max-len */
import { IonSearchbar } from '@ionic/react';
import styled from 'styled-components';
import { AllieSearchbarProps } from './Searchbar.types';

export const StyledContainerSearch: any = styled('div')`
  font-family: var(--ion-font-family);
  width: 100%;
`;

export const StyledSuggestions: any = styled('div')`
  position: absolute;
  top: 100%;
  height: fit-content;
  max-height: 340px;
  border-bottom: 0.5px solid var(--allie-color-neutral-30);
  z-index: 3001;
  min-width: 0;
  padding: 0 1px;
  bottom: 0;
  overflow-y: auto;
  background-color: white;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);

  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: darkgray;
  }
`;

export const StyledSuggestionList: any = styled('ul')`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-bottom: 8px;
  margin-right: -1px;
  border-top: solid 1px #e6e6e6;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #fff;
`;

export const StyledSuggestionItem: any = styled('li')`
  padding: 8px 16px;
  cursor: pointer;
  color: var(--allie-color-neutral-90);
  display: flex;
  align-items: center;
  column-gap: 12px;
  ${(props: any) => (!props.disableHover ? '&:hover { background-color: #f2f2f2; };' : '')}
  ${(props: any) => (props.active ? 'background-color: #f2f2f2;' : '')}

  .tag-item {
    border: 1px solid var(--allie-color-neutral-30);
    padding: 2px 8px;
    border-radius: 16px;
    color: var(--allie-color-neutral-40);
  }
`;

export const StyledAddItemList: any = styled('ul')`
  list-style: none;
  padding: 0;
  margin: 0;
  border-top: solid 1px #e6e6e6;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  border-bottom-right-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
`;

export const StyledAddItem = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--allie-spacing-sm);
  padding: var(--allie-spacing-sm);

  &:hover {
    background-color: var(--allie-color-neutral-10);
  }
`;

export const StyledNoResultsItem: any = styled('li')`
  list-style: none;
  padding: 8px 16px;
  text-align: center;
  color: var(--allie-color-neutral-90);
  background-color: var(--allie-color-light-80);
`;

export const StyledMoreResultsItem: any = styled('li')`
  padding: 8px 16px;
  text-align: center;
  color: var(--allie-color-neutral-90);
  background-color: var(--allie-color-neutral-20);
`;

export const StyledSearchbar: any = styled(IonSearchbar)<AllieSearchbarProps>`
  --background: ${(props: AllieSearchbarProps) =>
    `var(--allie-color-${props.backgroundColor || 'white'})`};

  ${(props: AllieSearchbarProps) => !props.boxShadow && '--box-shadow: none;'}

  --border-radius: 8px;
  --placeholder-color: var(--allie-color-neutral-50);
  --color: var(--allie-color-neutral-90);
  text-align: left;
  .searchbar-input-container {
    min-height: 41px;
  }
  .searchbar-input {
    font-size: 14px;
  }
  ${(props: AllieSearchbarProps) =>
    props.hasBorder &&
    `&& input {
      border: 1px solid var(--allie-color-neutral-30);
      padding-top: 5px;
      padding-bottom: 5px;
      font-size: 12px;
    };
    && ion-icon {
      width: 20px;
      height: 20px;
    }
    `}
`;
